export const bpInfo = {version: 'v3.27.0'};
